// extracted by mini-css-extract-plugin
module.exports = {"container":"page-indicator_container_1QZ6i","wrapper":"page-indicator_wrapper_NflJ5","circle":"page-indicator_circle_CZRaa","line":"page-indicator_line_3bj_P"};